module.exports = __webpack_public_path__ + "static/media/ic_close-red.e212f9e8.svg";